module.exports = __webpack_public_path__ + "img/explore_beimen.70d13241.png";